module.exports = __webpack_public_path__ + "media/images/athletes/2105-53b9bb7ef4ad9feb286b7af6d15939a4.png";